@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../constants/spacing.module.less';

@settingsWidth: 850px;
// @design-input-pending
@temporary-divider-color: var(--gray-DFE4E8);

.content {
  max-width: @settingsWidth;
}

.divider {
  border-color: @temporary-divider-color;
}

.top-content {
  display: flex;
  flex-direction: column;
  gap: @space-24;
  margin: @space-0 @space-0 @space-24 @space-0;
}

.reprocess-section {
  display: flex;
  flex-direction: column;
  gap: @space-24;
  margin: @space-24 0;

  .reprocess-description {
    line-height: 1.3;
    margin: 20px 0;
  }

  .reprocess-action {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: auto;
  }
}

.create-button {
  white-space: nowrap;
}

.create-icon {
  width: 10px;
  height: 10px;
  margin-right: 5px;
}

.primary-action {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  margin-bottom: 10px;
  justify-content: space-between;
}

.dropdown-toggler {
  width: 100%;
  background-color: @settings-page--automation-rules-dropdown--background-color;
  height: 32px;
  border-radius: 4px;
  border: 1px solid @settings-page--automation-rules-dropdown--border-color;
  &:active,
  &:hover {
    background-color: @settings-page--automation-rules-dropdown--hover--background-color;
    border-top: 1px solid @settings-page--automation-rules-dropdown--hover--border-color;
  }
}

.dropdown-item {
  width: 100%;
  display: flex;
  align-items: center;
  > div {
    margin-right: 10px;
  }
}

.dropdown-menu {
  width: 100%;
}

.show-inactive {
  align-self: center;
}

.page-description {
  .page-description-text {
    margin: 0 0 8px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.external-link-icon {
  width: 20px;
  padding: 0 5px;
}

.promotionalBannerContainer {
  margin-bottom: @space-16;
}

.page-wrapper {
  display: flex;
  flex-direction: column;
}

.page-header {
  display: flex;
  flex-direction: column;
  gap: @space-16;
  background: var(--Surface-Container);
  padding: @space-16 @space-24;
}

.tabs-section {
  background: var(--Surface-Default);
  flex: 1;
}

.bottom-content {
  display: flex;
  flex-direction: column;
  gap: @space-16;
  padding: @space-16;
  background: var(--Surface-Container);
  border-radius: 8px;
  border: 1px solid var(--Border-Medium);
}

.tab-list-padding {
  padding: 0 @space-24;
  background: var(--white);
}

.selected-tab {
  background: var(--Surface-Default);
}

.tab-panel-content {
  padding: @space-24;
}

.tab {
  padding: @space-8 @space-16;
}

.tab-with-badge {
  display: flex;
  align-items: center;
  gap: @space-8;
}

.legacy {
  margin-bottom: @space-24;
}
